import React from 'react';
import PropTypes from 'prop-types';
import {useSearchParams} from "react-router-dom";
import {Pagination as AntdPagination} from "antd";

const Pagination = ({pagesCount, total, currentPage, handlePageClick, perPage, useParams, isDisabled, children, contentClassName = ''}) => {

    const [searchParams, setSearchParams] = useSearchParams()

    const onPageClick = async(page) => {
        if(useParams) {
            let params = new URLSearchParams(searchParams);
            params.set('page', String(page));
            return setSearchParams(params, {replace: true});
        }
        if(handlePageClick) return handlePageClick(page);
    }

    return (
        <div className={"flex justify-between flex-row item-center " + contentClassName}>
            {children}

            {pagesCount > 1 && (
                <AntdPagination
                    showSizeChanger={false}
                    showLessItems={true}
                    pageSize={perPage}
                    showPrevNextJumpers={false}
                    showQuickJumper={false}
                    current={currentPage}
                    total={total}
                    onChange={onPageClick}
                    disabled={isDisabled}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${TB.pluralize("result", total, true)}`}
                />
            )}
        </div>
    )
}

Pagination.propTypes = {
    pagesCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    isDisabled: PropTypes.bool
};

export default Pagination